import {HTMLAttributes, ReactNode} from 'react';
import FormHelperText, {FormHelperTextProps} from '@material-ui/core/FormHelperText';
import {v4} from '@utils/uuid';
import classnames from 'classnames';
import {useDesignContext} from '@theme';
import {TextFieldProps} from '@material-ui/core';
import AppInputLabel from '../../labels/AppInputLabel/AppInputLabel';
import BaseInput from '../BaseInput/BaseInput';
import './appInput.less';

type AppInputProps = Omit<TextFieldProps, 'variant'> & {
    label?: ReactNode;
    helperText?: ReactNode;
    error?: boolean;
    disabled?: boolean;
    htmlFor?: string;
    dataWdio?: string;
    readOnly?: boolean;
    helperTextProps?: FormHelperTextProps
    labelProps?: HTMLAttributes<HTMLLabelElement>
    formatErrorLabel?: unknown
};

export function AppInput({
    label,
    helperText,
    error,
    disabled,
    readOnly,
    className,
    id,
    required,
    inputRef,
    htmlFor,
    // props
    inputProps,
    labelProps,
    helperTextProps,
    // mui props which throws an error because we don't need them
    InputLabelProps,
    formatErrorLabel,
    dataWdio,
    ...rest
}: AppInputProps) {
    const {designVersion} = useDesignContext();

    const classNames = classnames('app-input-container', className, designVersion, {
        disabled, required, error, readOnly
    });

    const uid = v4();
    const htmlForId = htmlFor !== undefined ? htmlFor : id || uid;
    const props = {
        ...rest,
        id: id || htmlForId,
        disabled: disabled || readOnly,
        required,
        error,
        inputProps,
        className: designVersion
    };

    return (
        <div className={classNames}>
            {label && (
                <AppInputLabel
                    disabled={disabled}
                    error={error}
                    htmlFor={htmlForId}
                    required={required}
                    {...labelProps}
                >
                    {label}
                </AppInputLabel>
            )}
            <BaseInput
                {...(props as any)}
                dataWdio={dataWdio}
                ref={inputRef || inputProps?.ref}
            />
            {helperText && (
                <FormHelperText error={error} {...helperTextProps}>
                    {helperText}
                </FormHelperText>
            )}
        </div>
    );
}

export default AppInput;
